export default __webpack_public_path__ + "static/media/addOnBenefitshelp.cca79175.png";